import React, { useEffect, useState } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import { getKeyProviders } from '../../../actions/keyProviderActions';
import { useForm } from 'react-hook-form';
import { bulkUpload } from '../../../actions/keyCodeActions';
import BulkIngestForm from './BulkIngestForm';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../hooks';

export interface BulkIngestProps {
  done: () => void;
  cancel: () => void;
}

function BulkIngest({ done, cancel }: BulkIngestProps) {
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();
  const { t } = useTranslation();
  const keyProviders = useAppSelector((state) => state.keyProviders);
  const dispatch = useAppDispatch();

  const [ingest, setIngest] = useState<{ files?: any[] }>();

  const addFiles = (files: any[]) => {
    setIngest({
      ...ingest,
      files: [...(ingest?.files ?? []), ...files],
    });
  };
  const onSubmit = (data: any) => {
    bulkUpload({ ...ingest, ...data })
      .then(() => {
        toast.success(t('Bulk key upload successfully'));
        done();
      })
      .catch((e) => {
        toast.error(e.message || t('Failed to upload bulk keys'));
      });
  };

  useEffect(() => {
    if (!keyProviders) {
      dispatch(getKeyProviders());
    }
  }, [dispatch, keyProviders]);

  return (
    <SlideoutLayout title={t('Bulk upload keys')} cancel={cancel}>
      <BulkIngestForm
        keyProviders={keyProviders}
        register={register}
        errors={errors}
        control={control}
        cancel={cancel}
        submit={handleSubmit(onSubmit)}
        addFiles={addFiles}
        files={ingest?.files}
        removeFile={(x) => {
          setIngest({
            ...ingest,
            files: ingest?.files?.filter((file) => file !== x),
          });
        }}
      />
    </SlideoutLayout>
  );
}

export default BulkIngest;
